module.exports = __webpack_public_path__ + "static/media/notif-config.cfb4c7bf.jpg";